function refresh(){renderSet();}

function renderTray(){
  const m=materials[chosen.mat],col=m.colors[chosen.color];
  let items=[{img:col.g[0],n:m.name.split(" ")[0],c:chosen.qty}];
  if(chosen.dyne&&chosen.dyne.on){var _do=dyneOpt(chosen.dyne.opt);if(_do)items.push({img:_do.img,n:"Dyne",c:1});}
  if(chosen.lagen.on)items.push({img:lagenColors[chosen.lagen.ci].img,n:lagenColors[chosen.lagen.ci].name,c:chosen.lagen.qty});
  if(chosen.pude.qty>0)items.push({img:PUDE_IMG,n:"Pude",c:chosen.pude.qty});
  if(chosen.pb.qty>0)items.push({img:pudeColors[chosen.pb.ci].img,n:pudeColors[chosen.pb.ci].name,c:chosen.pb.qty});
  simpleAddons.forEach(a=>{if(chosen.simple[a.key])items.push({img:a.img,n:a.short,c:1});});
  document.getElementById("trayitems").innerHTML=items.map(it=>`<div class="titem"><div class="tim"><img src="${im(it.img)}" alt=""></div>${it.c>1?`<span class="cnt">${it.c}</span>`:''}<div class="tn">${it.n}</div></div>`).join("");
}
function updateTotal(){
  const m=materials[chosen.mat],col=m.colors[chosen.color],s=sizeObj();
  let total=s.price*chosen.qty,count=0;
  if(chosen.dyne&&chosen.dyne.on){var _ds=dyneSizeData(dyneOpt(chosen.dyne.opt),chosen.size);if(_ds){total+=_ds.price;count++;}}
  if(chosen.lagen.on){total+=lagenTotal();count++;}
  if(chosen.pude.qty>0){total+=chosen.pude.qty*359;count++;}
  if(chosen.pb.qty>0){total+=chosen.pb.qty*pbUnit();count++;}
  simpleAddons.forEach(a=>{if(chosen.simple[a.key]){total+=a.price;count++;}});
  const qtyTxt=chosen.qty>1?` · ${chosen.qty} sæt`:'';
  document.getElementById("bartitle").textContent=`${m.name} · ${col.name} · ${chosen.size}${qtyTxt}${count?` + ${count} tilvalg`:''}`;
  document.getElementById("bartotal").textContent=total.toLocaleString("da-DK");
  const bp=document.getElementById("bp");bp.classList.add("bump");setTimeout(()=>bp.classList.remove("bump"),200);
}
